import { createBrowserClient } from '@supabase/ssr'

export function createClient() {
  // Use environment variables - these should match your .env.local file
  const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL || 'https://xvjhggjntkrrxajzdwgf.supabase.co'
  const supabaseKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inh2amhnZ2pudGtycnhhanpkd2dmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzM1MzIzNjIsImV4cCI6MjA0OTEwODM2Mn0.PF3_c4HUv4Xt0XTnTU7H5XGdkZGY2w8-cQVx4DJgHHs'
  
  return createBrowserClient(supabaseUrl, supabaseKey)
}

// Export a default instance for use in calendar.ts
export const supabase = createClient()
